import { Toaster } from "ui-widgets";
import AuthService from "./AuthService";
import InfoSection from "datalign-module-template/models/info-sections";
export default class InfoSectionService {
  public readonly infoSectionsService = {
    list: async () => {
      const r = await fetch(`${process.env.REACT_APP_API_HOST}/info_sections`, {
        method: "GET",
        headers: AuthService.siteletHeaders,
        credentials: "include",
      });
      if (r.ok) {
        const resp = await r.json();

        if (resp?.errors) {
          Toaster.makeToast("Error on query", "error");
        }
        return resp?.results as InfoSection[];
      }
    },
  };
}
